<template>
  <section class="acc--create-basic">
    <v-container grid-list-md>
      <v-form v-model="valid" @submit="saveUser">
        <v-layout row wrap>
            <v-flex sm12>
              <div class="acc--create-header">
                <div class="acc--create-header-grid">
                  <div>
                    <p class="acc--create-subtitle">Create A New</p>
                    <p class="acc--create-title">User</p>
                  </div>
                  <div class="acc--create--header--span-3">
                    <p class="acc--create-subtitle">Account Creator</p>
                    <p class="acc--create-title">{{this['user/user'].name}}</p>
                  </div>
                  <div class="acc--create--header--span-2">
                    <v-btn depressed color="primary" type="submit" :disabled="!valid">Save</v-btn>
                    <v-btn depressed color="primary" :disabled="!valid">Save And New</v-btn>
                  </div>
                </div>
              </div>
            </v-flex>
            <v-flex sm12 md12 lg12>
                <v-card class="acc--create-card">
                  <p>BASICS</p>
                  <div class="acc--create-pd">
                    <div class="acc--create-grid">
                      <div>
                        <v-text-field label="USER NAME" v-model="form.name" :rules="userNameRules"/>
                      </div>
                      <div>
                        <v-text-field label="EMAIL" v-model="form.email" :rules="emailRules" />
                      </div>
                      <div>
                        <v-autocomplete
                          :loading="loading"
                          :items="dropdown_company"
                          item-value="text"
                          flat
                          label="COMPANY"
                          :rules="companyRules"
                          v-model="form.company"
                          :search-input.sync="search"
                          clearable
                          persistent-hint
                          allow-overflow
                          return-object
                        />
                      </div>
                      <div>
                        <v-text-field label="PHONE" v-model="form.phone" />
                      </div>
                    </div>
                  </div>
                </v-card>
            </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </section>
</template>
<script>
import { coreClient } from "../../apollo";
import gql from "graphql-tag";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      dropdown_company: [],
      userNameRules: [
        v => !!v || "The name is required",
        v => (v || "").length > 2 || "The name must be atleast 2 characters."
      ],
      emailRules: [
        v => !!v || "The email is required.",
        v =>
          /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
            v
          ) || "Please enter a valid email address."
      ],
      companyRules: [v => !!v || "The company is required."],
      valid: false,
      form: {
        name: "",
        email: "",
        company: "",
        phone: ""
      },
      loading: false,
      search: null
    };
  },
  methods: {
    async getCompanies(variables = {}) {
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Companies($name: String, $limit: Int) {
              Companies(name: $name, limit: $limit) {
                docs {
                  id
                  name
                  logo
                  address
                  phone
                }
              }
            }
          `,
          variables: { ...variables, limit: 20 }
        });

        this.dropdown_company = data.Companies.docs.map(doc => {
          return { ...doc, text: doc.name };
        });
      } catch (e) {
        // handle the error.
      }
    },
    async saveUser(e) {
      e.preventDefault();
      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation createUser(
              $name: String!
              $email: String!
              $company: String!
              $phone: String
            ) {
              createUser(
                name: $name
                email: $email
                company: $company
                phone: $phone
              ) {
                id
              }
            }
          `,
          variables: {
            ...this.form,
            company: this.form.company.id
          }
        });

        const { createUser } = data;

        setTimeout(() => {
          this.$router.push("/user-accounts/" + createUser.id);
        }, 500);
      } catch (e) {
        // handle this later.
      }
    }
  },
  computed: {
    ...mapGetters(["user/user"])
  },
  watch: {
    async search(v) {
      if (!v) {
        this.form.company = "";
        await this.getCompanies();
        return;
      }

      this.loading = true;
      v && v !== this.form.company && (await this.getCompanies({ name: v }));
      this.loading = false;
    }
  },
  async mounted() {
    await this.getCompanies();
  }
};
</script>
<style lang="stylus" scoped>
@import '../../assets/stylus/UserAccounts_create.styl';
</style>
